import React, { useState } from 'react';
import { formatAmount, formatAmountString } from '../utils/format';
import { useTranslation } from 'react-i18next';
import noImage from '../icons/noImageIcon.svg';
import ProductPopup from '../modules/Products/ProductPopup';
import discountIcon from '../icons/discount.svg';


const ProductRow = ({ product, variant = 'default' }) => {
    const { t } = useTranslation();
    const [imageError, setImageError] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    if (!product) return null;

    const handleImageError = (e) => {
        setImageError(true);
        e.target.src = noImage;
    };

    const tva = product?.vatRate ?? product?.product?.vatRate ?? 20;
    const unitPrice = product?.unitPrice ?? product?.product?.priceHT ?? 0;
    const unitPriceTTC = unitPrice * (1 + tva / 100);

    const handleProductClick = (product) => {
        setSelectedProduct(product);
    };

    return (
        <div className="grid grid-cols-[20%_15%_10%_15%_10%_10%_20%] items-center bg-white p-2 rounded-[12px] shadow-[0px_6px_26px_rgba(98,107,125,0.07)]">
            <div className="flex items-center space-x-2 ml-4"
                onClick={() => product?.product?.id && handleProductClick(product.product.id)}
            >
                <div>
                    <div className="flex items-center gap-2 ">
                        {(product?.product?.discount > 0 || product?.discount > 0) && product?.discount !== null && (
                            <p className="inline-flex items-center gap-1 text-[12px] bg-[#FFD700] rounded-[12px] px-1 py-0.5 font-bold text-[#043F88]">
                                <img src={discountIcon} alt="discount" className="w-3 h-3" />
                                <span>{product?.product?.discount ?? product?.discount ?? 0}%</span>
                            </p>
                        )}
                    </div>
                    <p className="text-primary font-semibold">
                        {product?.product?.name ?? product?.designation ?? ''}
                    </p>
                    {product?.changeRequestedBy && (
                        <p className="text-[#EF466F] text-[12px] font-semibold">
                            {product.changeRequestedBy === 'CLIENT'
                                ? t('rows.requestedByClient')
                                : product.changeRequestedBy === 'WORKSHOP_MANAGER'
                                    ? t('rows.requestedByWorkshopManager')
                                    : product.changeRequestedBy}
                        </p>
                    )}
                </div>
            </div>


            {/* Price HT */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.priceuHT').toUpperCase()}
                </p>
                {(
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(product?.unitPrice ?? product?.product?.priceHT ?? 0)}
                    </p>
                )}
            </div>

            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">TVA (%)</p>
                <p className="text-[#043F88] text-[20px] font-semibold">{tva}%</p>
            </div>

            {/* Price TTC */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.priceuTTC').toUpperCase()}
                </p>
                {(
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(unitPriceTTC ?? product?.product?.priceTTC ?? 0)}
                    </p>
                )}
            </div>

            {/* Discount */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.discount').toUpperCase()}
                </p>
                <p className="text-[#043F88] text-[20px] font-medium">
                    {product?.salesDiscount ?? 0}%
                </p>
            </div>

            {/* Quantity */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.quantity').toUpperCase()}
                </p>
                <p className="text-[#043F88] text-[20px] font-medium">
                    {product?.quantity ?? 0}
                </p>
            </div>




            {/* Total Price */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.totalPrice')}
                </p>
                {(
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(product?.priceTTC ?? 0)}
                    </p>
                )}
                {product?.advancePayment ? (
                    <p className="text-[12px] font-semibold text-[#06D6A0]">
                        {`AC: ${formatAmountString(product?.advancePayment)}`}
                    </p>
                ) : null}
            </div>

            {selectedProduct && (
                <ProductPopup
                    productId={selectedProduct}
                    onClose={() => setSelectedProduct(null)}
                />
            )}
        </div>
    );
};

export default ProductRow;
